"use client";
import { useState } from "react";
import InitialSurvey from "./InitialSurvey";
import { dictionary } from "../utils/dictionary";
import { Language } from "../utils/dictionary";
import { useAuth } from "../context/AuthContext";

export default function StartSurvey() {
  const [started, setStarted] = useState(false);
  const { language } = useAuth();

  if (started) {
    return <InitialSurvey />;
  }

  return (
    <div className="fixed inset-0 z-[9999] bg-[#F5F6FA] font-['Plus_Jakarta_Sans',sans-serif] overflow-y-auto">
      {/* Background Gradient - Fixed to cover entire viewport */}
      <div
        className="fixed inset-0 z-0 pointer-events-none"
        style={{
          backgroundImage:
            "linear-gradient(rgba(62, 62, 255, 0) 0%, rgba(62, 110, 255, 0.2) 100%), linear-gradient(90deg, rgb(255, 255, 255) 0%, rgb(255, 255, 255) 100%)",
        }}
      />

      <div className="relative z-10 min-h-screen flex flex-col items-center justify-center container mx-auto px-4 sm:px-6 md:px-8 lg:px-12 py-8 sm:py-12 md:py-16 lg:py-20">
        <div className="w-full max-w-2xl mx-auto">
          <h1 className="text-[#0E172A] font-extrabold text-3xl sm:text-4xl md:text-5xl lg:text-[58px] leading-[1.1] mb-6 sm:mb-8 text-center sm:text-left">
            {dictionary["survey-title"][language as Language]}
          </h1>
          <div className="flex justify-center sm:justify-start">
            <button
              onClick={() => setStarted(true)}
              className="w-full sm:w-auto bg-[#0E172A] hover:bg-[#0E172A]/80 active:bg-[#0E172A]/70 text-white text-base sm:text-lg md:text-xl lg:text-2xl font-semibold py-3 sm:py-4 px-6 sm:px-8 rounded-xl transition-all duration-300 hover:scale-105 active:scale-95 flex items-center justify-center gap-2"
            >
              <span>{dictionary["start-survey"][language as Language]}</span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={2}
                stroke="currentColor"
                className="w-5 h-5 sm:w-6 sm:h-6 flex-shrink-0"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
